<!--<style lang='less' scoped>-->
<!--@import '../base.less';-->

<!--</style>-->
<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.url' :placeholder="$t('请输入域名') "></Input>
            </FormItem>

            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isZhong'
                                                      :placeholder="$t('最新一期是否准') " style='width:120px'>
              <Option :value="'错'">{{ $t('错') }}</Option>
              <Option :value="'准'">{{ $t('准') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isXg' clearable
                                                      :placeholder="$t('类型') " style='width:120px'>
              <Option :value="'0'">{{ $t('澳门') }}</Option>
              <Option :value="'1'">{{ $t('香港') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('编辑') }}</span>
      </p>


      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" label-position="left"
            :label-width="60">

        <FormItem label='玩法'>
          <Select v-model="extraParams['field_id']" @on-select="selectWf" filterable style='width:200px' clearable>
            <Option :value="value['id']" v-for="(value, key) in extraParams['options']">{{
                $t(value['fieldName'])
              }}
            </Option>
          </Select>

          <Button type="error" @click="getParams(extraParams['id'],'wf')" class="margin-left-10">{{
              $t('一键生成高准确率内容')
            }}
          </Button>
        </FormItem>

        <FormItem label='标题'>
          <Input v-model="extraParams['title']" :placeholder="$t('请输入标题,请根据玩法填写')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
          <Button type="info" @click="getParams(extraParams['id'],'title')" class="margin-left-10">{{
              $t('使用默认标题')
            }}
          </Button>
        </FormItem>

        <FormItem label='作者'>
          <Input v-model="extraParams['author']" :placeholder="$t('请输入作者')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
          <Button type="info" @click="getParams(extraParams['id'],'author')" class="margin-left-10">{{
              $t('随机一个')
            }}
          </Button>
        </FormItem>
        <p :prop="key" v-for="(value, key) in extraParams['data']">
          <FormItem :label="value['issue']+'期'">
            <Input v-model="value['code']" :placeholder="$t('购买号码')" :disabled="windowAddItem.id"
                   style="width: 200px;"></Input>
            <Button type="info" @click="getParams(extraParams['id'],value['issue'])" class="margin-left-10">{{
                $t('随机一个')
              }}
            </Button>
            <span style="margin-left: 15px ;color: red">{{ '开' + value['opened'] + value['isZhun'] }}</span>
          </FormItem>
        </p>

        <FormItem style="margin-bottom:4px" label='页面广告' prop='body'>
          <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{
              $t('编辑源码')
            }}
          </Button>

          <div v-if="isHtml==false" style="border: 1px solid #ccc;">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 200px; overflow-y: hidden;"
              v-model="extraParams['ad1']"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
            />
          </div>
          <textarea v-if="isHtml==true" v-model="extraParams['ad1']" name="ckeditor" rows="10" cols="80"></textarea>
          <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>
        <br>
        <div v-html="extraParams['tem']"></div>
      </Form>

      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'


import {
  getList,
  add,
  del,
  lock,
  getParams,
  yulan,
  changeStatus
} from '@/api/LhcManage/LhcAmBBSZhiliao'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

import {baseUrl} from '@/libs/api.request'
import CKEDITOR from 'CKEDITOR'
import {getToken} from '@/libs/util'

export default {
  name: 'interface_list',
  components: {Editor, Toolbar},

  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple',
      isHtml: false,

      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('序号'),
        type: 'index',
        width: 60,
        minWidth: 40,
        align: 'center'
      }, {
        title: this.$t('类型'),
        key: 'position',
        width: 80,
        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('域名'),
        key: 'url',
        width: 120,
        minWidth: 88,
        align: 'center'
      }, {
        title: this.$t('玩法'),
        key: 'fieldName',
        width: 180,
        minWidth: 150,
        align: 'center'
      }, {
        title: this.$t('作者'),
        key: 'author',
        width: 100,
        minWidth: 50,
        align: 'center'
      }, {
        title: this.$t('标题'),
        key: 'title',
        minWidth: 70,
        align: 'center'
      }, {
        title: this.$t('最近一期是否准'),
        align: 'center',
        width: 150,
        minWidth: 80,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.isZhong != '准' ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.isZhong != '准' ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.isZhong),
          ])
        }
      }, {
        title: this.$t('是否前台显示'),
        align: 'center',
        width: 200,
        minWidth: 80,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.filename == '不显示' ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.filename == '不显示' ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.filename),
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 180,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                this.getParams(params.row.id);
              }
            }
          }, this.$t('编辑资料')),h('Button', {
            props: {
              type: 'error'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                yulan(params.row.id).then(response => {
                  window.open(params.row.testUrl+'/temp.htm','_blank')
                })

              }
            }
          }, this.$t('预览效果'))])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: {id: 0},
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        config_user: '',
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
      },
      windowAddValidate: {//窗口校验规则
      },
      //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcAmBBSZhiliao/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcAmBBSZhiliao/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcAmBBSZhiliao/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })

    this.searchConf.isXg = this.$route.params.isXg
    this.searchConf.url = this.$route.params.url ? this.$route.params.url : ''
  },
  mounted() {


  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },

    // preAdd() {
    //   this.windowAdd.show = true
    // },
    getParams(id, key = '') {
      let vm = this
      if (key == '') {//新点击的时候
        this.isHtml=false;
        getParams({'id': id}).then(response => {
          this.extraParams = response.data.data
          vm.windowAdd.show = true
        })
      } else {
        //如果是变化,则把所有数据带过去
        this.extraParams.id = id;
        this.extraParams.key = key;
        getParams(this.extraParams).then(response => {
          this.extraParams = response.data.data
          vm.windowAdd.show = true
        })
      }
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      this.extraParams.isSave = 1;
      this.extraParams.key = '';
      getParams(this.extraParams).then(response => {
        this.extraParams.isSave = 0;
        this.$Message.success(response.data.msg)
        this.windowAddCancel()
        this.getList();
      })

    },
    selectWf(param){
      this.getParams(this.extraParams['id'],"wf|"+param.value);
    }
  }
}
</script>
